<template>
    <div v-if="penalties.length" class="d-flex flex-column justify-center">
        <h3 class="font-weight-light text-center">Permanencias</h3>
        <v-chip-group outlined v-if="!$vuetify.breakpoint.smAndDown">
            <v-chip
                v-for="(permanency, index) in penalties" 
                :key="index" 
                :color="isActive(permanency.endDate) ? 'success' : 'red darken-3'"
                outlined 
                class="px-2 py-9"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex flex-column" v-on="on" v-bind="attrs">
                            <div class="text-center">
                                {{ permanency.description }}
                            </div>
                            <div class="text-center">
                                <v-icon small left>
                                    {{ permanency.subscriptionSubType === "POSTPAID" ? 'mdi-cellphone' :
                                        permanency.subscriptionSubType === "LANDLINE" ? 'mdi-phone' :
                                        permanency.subscriptionSubType === "AGILETV" ? 'mdi-television' :
                                        permanency.subscriptionSubType === "FTTH" ? 'mdi-wifi' :
                                        undefined }}
                                </v-icon>
                                <v-icon class="mx-2" small color="orange" v-if="permanency.isMandatory">
                                    mdi-alert-outline
                                </v-icon>
                                {{ permanency.penaltyPrice }}
                                <v-icon small>
                                    mdi-currency-eur
                                </v-icon>
                            </div>
                            <div class="text-center">
                                {{ permanency.beginDate }} 
                                <v-icon small>
                                    mdi-arrow-right
                                </v-icon>
                                <span v-if="permanency.endDate">
                                    {{ permanency.endDate }}
                                </span>
                                <v-icon
                                    v-else
                                    small
                                >
                                    mdi-infinity
                                </v-icon>
                            </div>
                        </div>
                    </template>
                    <span>{{ permanency.description }}</span>
                    <span
                        :class="permanency.isMandatory ? 'orange--text' : 'white--text'"
                    >{{ permanency.isMandatory ? ' obligatorio' : ' no obligatorio' }}</span>
                </v-tooltip>
            </v-chip>
        </v-chip-group>
        <div v-else class="d-flex flex-column">
            <v-chip
                v-for="(permanency, index) in penalties" 
                :key="index" 
                :color="isActive(permanency.endDate) ? 'success' : 'red darken-3'"
                outlined 
                class="px-2 py-9 my-1 d-flex justify-center"
            >
                <div class="d-flex flex-column justify-center">
                    <div class="text-center">
                        {{ permanency.description }}
                    </div>
                    <div class="text-center">
                        {{ permanency.penaltyPrice }}
                        <v-icon small>
                            mdi-currency-eur
                        </v-icon>
                    </div>
                    <div class="text-center">
                        {{ permanency.beginDate }}
                        <v-icon small>
                            mdi-arrow-right
                        </v-icon>
                        <span>
                            {{ permanency.endDate }}
                        </span>
                    </div>
                </div>
            </v-chip>
        </div>
    </div>
    <h3 class="font-weight-light grey--text text-center" v-else>No hay permanencias activas</h3>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        penalties: []
    }),
    props: {
        serviceNumber: {
            type: String,
        },
        selectedContractId: {
            type: String,
        },
        types: {
            type: Array,
        },
    },
    computed: {
        ...mapState('agent', {
            agentCustInfo: (state) => state.agentCustInfo,
        }),
    },
    methods: {
        isActive(date) {
            return !date || new Date(date) > new Date();
        }
    },
    mounted() {
        let penal = [];
        for (const [account_id, account] of Object.entries(this.agentCustInfo)) {
            const contract = account[this.selectedContractId];
            const all_penalties = contract.permanencies.permanencies;
            for (const [num, permanency] of Object.entries(all_penalties)) {
                if(permanency.number === this.serviceNumber && this.types.includes(permanency.subscriptionSubType)) {
                    penal.push(permanency);
                }
            }
        }

        this.penalties = penal.sort((a, b) => {
            if (!a.endDate && !b.endDate) return 0;
            if (!a.endDate) return -1;
            if (!b.endDate) return 1;

            // date is dd/mm/yyyy, parse it to yyyy-mm-dd
            const aDate = a.endDate.split('/').reverse().join('-');
            const bDate = b.endDate.split('/').reverse().join('-');

            return new Date(bDate).getTime() - new Date(aDate).getTime();
        });
    },
}
</script>